import React from 'react';
import { AlertBanner } from './components/AlertBanner';
import { Header } from './components/Header';
import { ArticleContent } from './components/ArticleContent';
import { Sidebar } from './components/Sidebar';
import { StickyCart } from './components/StickyCart';
import { MetaPixelTracker } from './components/MetaPixel';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <MetaPixelTracker data-id="element-1" />

      {/* Advertorial Label */}
      <div className="bg-gray-800 text-white text-center py-1 text-xs" data-id="element-2">
        Advertorial
      </div>

      {/* Alert Banner */}
      <AlertBanner data-id="element-3" />

      {/* Main Content Grid */}
      <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-5">
          {/* Main Content - Left Column */}
          <div className="lg:col-span-2" data-id="element-6">
            <Header data-id="element-7" />
            <ArticleContent data-id="element-8" />
          </div>

          {/* Sidebar - Right Column */}
          <div className="lg:col-span-1" data-id="element-9">
            <Sidebar data-id="element-10" />
          </div>
        </div>
      </div>

      {/* Sticky Cart */}
      <StickyCart data-id="element-11" />
    </div>;
}